import { render } from "./KnowledgeGraph.vue?vue&type=template&id=4b925ab0&scoped=true"
import script from "./KnowledgeGraph.vue?vue&type=script&lang=js"
export * from "./KnowledgeGraph.vue?vue&type=script&lang=js"

import "./KnowledgeGraph.vue?vue&type=style&index=0&id=4b925ab0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b925ab0"]])

export default __exports__